module.exports = "/assets/data/f456850594c23d14363aa4ef151fad69-WR9.data.json";